/**
 * Event Bus - A lightweight pub/sub system for component communication
 * 
 * This module provides a centralized event management system that allows
 * components to communicate without direct dependencies. It replaces
 * setTimeout-based coordination with an event-driven approach.
 * 
 * Using the mitt library: https://github.com/developit/mitt
 */

// Create a mitt instance
const eventBus = mitt();

// Add some simple debugging when in development
// Using window.location to check if we're on localhost
const isDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

if (isDev) {
  // Add logging for debugging when needed
  const originalEmit = eventBus.emit;
  eventBus.emit = function(type, ...args) {
    // Skip logging for common events that would create too much noise
    if (!type.includes('journeyData:available') && 
        !type.includes('tips:loadComplete') && 
        !type.includes('journey:loadComplete') && 
        !type.includes('tab:')) {
      console.log(`[EventBus] emit: ${String(type)}`);
    }
    return originalEmit.call(this, type, ...args);
  };
}

// Export the event bus as ES module
export default eventBus;

// Also make available globally for backward compatibility during transition
window.eventBus = eventBus;